
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadConversionSheetFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LeadConversionSheet"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"companyName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"termsAgreed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"termsOfNegotiation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"justification"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"expectedOtherBusiness"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":156}};
    doc.loc.source = {"body":"fragment LeadConversionSheetFields on LeadConversionSheet {\n  id\n  companyName\n  termsAgreed\n  termsOfNegotiation\n  justification\n  expectedOtherBusiness\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    



//////////////////
// WEBPACK FOOTER
// ./src/graphql/fragments/LeadConversionSheetFragment.graphql
// module id = 522
// module chunks = 0